<template>
  <v-ons-page @show="showPage()">

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        Sélection de l'agriculteur
      </div>
    </v-ons-toolbar>

    <div class="content">

      <p style="padding: 0 14px">
        <v-ons-search-input placeholder="Recherchez un agriculteur ou une société" v-model="clientName" :modifier="$mdModifier">
        </v-ons-search-input>
      </p>

      <v-ons-list modifier="noborder">

        <v-ons-list-item v-for="(item, index) in clientList.slice(0, pageSize)" modifier="nodivider" tappable @click="selectClient(item.id)" :key="'c'+index">
          <div class="center">
            {{ item.name }}
          </div>
        </v-ons-list-item>
        
        <v-ons-list-item v-if="clientList.length > pageSize" modifier="perfcours nodivider">
          <div class="center">
            <span class="label-grey">
              Affinez votre recherche
            </span>
          </div>
        </v-ons-list-item>

        <v-ons-list-item v-if="normalize(clientName).length && ! clientList.length" modifier="perfcours nodivider">
          <div class="center">
            <span class="label-grey">
              Aucun résultat trouvé
            </span>
          </div>
        </v-ons-list-item>

        <v-ons-list-item v-show="normalize(clientName).length" v-for="negoceInfos in negoce"
                         modifier="perfbutton" :key="negoceInfos.id">
          <v-ons-button modifier="quiet" @click="showClient(negoceInfos.id)">
            Ajouter un contact
            {{ negoce.length > 1 ? 'chez ' + negoceInfos.label : '' }}
          </v-ons-button>
        </v-ons-list-item>

      </v-ons-list>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

import AppVenteDemande from './VenteDemande.vue';
import AppClientEdit from './ClientEdit.vue';
import AppCultureTonne from './CultureTonne.vue';
import AppAlerteSeuil from './AlerteSeuil.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  props: ['pageStack'],
  data() {
    return {
      workflow: '',
      refCulture: '',
      refDestination: '',
      clientName: '',
      pageSize: 25,
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    negoceById() {
      var list = {};
      for (let j = 0; j < this.negoce.length; j++) {
        var negoceInfos = this.negoce[j];
        list[negoceInfos.id] = negoceInfos.label;
      }
      return list;
    },
    clients() {
      return this.data.negoce.clients;
    },
    negoce() {
      return this.getNegoceAcces(this.data.negoce.list);
    },
    clientList() {
      var clientName = this.normalize(this.clientName);
      if(! clientName.length){
        return [];
      }
      var list = [];
      for (const id in this.clients) {
        var client = this.clients[id];
        var name = client.name;
        if(client.societe){
          name = client.societe + ' (' + name + ')';
        }
        if(client.erp){
          name += ' • ' + client.erp;
        }
        if(! this.normalize(name).includes(clientName)){
          continue;
        }
        list.push({ id: id, name: name });
      }
      list.sort(function (a, b) { if (a.name > b.name) { return 1; } else { return -1; } });
      if(this.negoce.length > 1){
        var listName = [];
        for (let i = 0; i < list.length; i++) {
          if(i >= this.pageSize){
            break;
          }
          var clientItem = this.clients[list[i].id];
          var itemName = clientItem.societe ? clientItem.societe : clientItem.name;
          var index = listName.indexOf(itemName);
          if(index != -1){
            if(listName.filter(value => { return value == itemName; }).length == 1){
              list[index].name += ' (' + this.negoceById[this.clients[list[index].id].negoce] + ')';
            }
            list[i].name += ' (' + this.negoceById[clientItem.negoce] + ')';
          }
          listName.push(itemName);
        }
      }
      return list;
    }
  },
  methods: {
    normalize(value){
      // Test regex: [^azertyuiopqsdfghjklmwxcvbn -éëôïîè]
      return value.replace(/[ -\.'"/&]/g, '').toLowerCase().replace(/[éëè]/g, 'e').replace(/ïî/g, 'i').replace(/ô/g, 'o').replace(/ú/g, 'u').replace(/ç/g, 'c');
    },
    selectClient(clientId){
      if(this.clients[clientId]){
        var refCulture = this.refCulture;
        var refDestination = this.refDestination;
        var negoceId = this.clients[clientId].negoce;
        if(! negoceId){
          negoceId = this.negoce[0].id;
        }
        if(this.workflow == 'vente'){
          this.pageStack.push({
            extends: AppVenteDemande,
            data() {
              return {
                negoceId: negoceId,
                refCulture: refCulture,
                refDestination: refDestination,
                vente: {
                  client: clientId
                }
              }
            }
          });
        } else if(this.workflow == 'tonne'){
          this.pageStack.push({
            extends: AppCultureTonne,
            data() {
              return {
                refCulture: refCulture,
                refDestination: refDestination,
                client: clientId
              }
            }
          });
        } else if(this.workflow == 'alerte'){
          this.pageStack.push({
            extends: AppAlerteSeuil,
            data() {
              return {
                refCulture: refCulture,
                refDestination: refDestination,
                client: clientId
              }
            }
          });
        } else if(this.workflow == 'campagne'){
          store.state.client.id = clientId;
          store.state.client.negoceId = negoceId;
          this.pageStack.length > 2 && this.pageStack.splice(this.pageStack.length - 2, 2);
          this.sendTrackEvent('tc ' + clientId);
        }
      }
    },
    showClient(negoceId) {
      this.pageStack.push({
        extends: AppClientEdit,
        data() {
          return {
            negoceId: negoceId
          }
        }
      });
      this.clientName = '';
    },
    showPage() {
      this.$setAutoFocus(this.$el, 'ons-search-input');
    }
  }
}
</script>
